/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cancel_Request_Field_Reason_PlaceholderInputs */

const en_cancel_request_field_reason_placeholder = /** @type {(inputs: Cancel_Request_Field_Reason_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Briefly explain why this ticket should be cancelled.`)
};

const ja_cancel_request_field_reason_placeholder = /** @type {(inputs: Cancel_Request_Field_Reason_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このチケットをキャンセルする理由を簡潔に説明してください。`)
};

const fr_cancel_request_field_reason_placeholder = /** @type {(inputs: Cancel_Request_Field_Reason_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expliquez brièvement pourquoi ce ticket doit être annulé.`)
};

const de_cancel_request_field_reason_placeholder = /** @type {(inputs: Cancel_Request_Field_Reason_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erklären Sie kurz, warum dieses Ticket storniert werden soll.`)
};

/**
* | output |
* | --- |
* | "Briefly explain why this ticket should be cancelled." |
*
* @param {Cancel_Request_Field_Reason_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const cancel_request_field_reason_placeholder = /** @type {((inputs?: Cancel_Request_Field_Reason_PlaceholderInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cancel_Request_Field_Reason_PlaceholderInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cancel_request_field_reason_placeholder(inputs)
	if (locale === "ja") return ja_cancel_request_field_reason_placeholder(inputs)
	if (locale === "fr") return fr_cancel_request_field_reason_placeholder(inputs)
	return de_cancel_request_field_reason_placeholder(inputs)
});